import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useTimeseriesQuery from '../useTimeseriesQuery';
import { globalOrderBySelector } from '@store/trends/base/selectors';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';

function useSecondaryQuery() {
  const metric = useSelector(globalOrderBySelector);
  const { query: baseQuery, ...rest }: any = useTimeseriesQuery();

  const query = useMemo(() => {
    const metrics = [metric];
    if (metric in INVERTED_METRIC_SWITCH_MAP) {
      metrics.push(INVERTED_METRIC_SWITCH_MAP[metric]);
    }
    return { ...baseQuery, metrics };
  }, [baseQuery, metric]);

  return { ...rest, query, metrics: query.metrics };
}

export default useSecondaryQuery;
